// 旧記事内に登録されている「滋賀の観光を楽しむ情報はこちらから」のバナー群を削除
// SSI などで共通のコードを読み込んでいるものと思ったら、各記事ごとにハードコーディングされているため、ある程度 JS で取得して削除することにしている
const $target = $('.article-body').find('strong:contains("滋賀の観光を楽しむ情報はこちらから")').closest('div'); // ターゲットに名前をつけて、CSS 側で一致を確認して非表示させる
// JS 側で一括非表示にすると想定外のものが出てくる可能性があるため

$target.addClass('-old-banners');